export default "__VITE_ASSET__BfWD09BM__"